module.exports = __webpack_public_path__ + "static/flags/WA-3997a7f5546b3e696245132e610f6933.gif";